var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2797 5.67993V13.2159C15.2798 13.4041 15.2061 13.5849 15.0745 13.7195C14.9429 13.854 14.7639 13.9317 14.5757 13.9359H1.42373C1.23556 13.9317 1.05651 13.854 0.924922 13.7195C0.793337 13.5849 0.71968 13.4041 0.719727 13.2159V5.67993",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21537 3.39209C3.17723 3.47796 3.15552 3.57022 3.15137 3.66409C3.17636 3.82652 3.25866 3.97464 3.38339 4.08164C3.50812 4.18865 3.66703 4.24748 3.83137 4.24748C3.99571 4.24748 4.15462 4.18865 4.27935 4.08164C4.40407 3.97464 4.48638 3.82652 4.51137 3.66409C4.50721 3.57022 4.48551 3.47796 4.44737 3.39209",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83984 3.64796V2.06396",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7833 3.39209C12.8214 3.47796 12.8432 3.57022 12.8473 3.66409C12.8223 3.82652 12.74 3.97464 12.6153 4.08164C12.4906 4.18865 12.3316 4.24748 12.1673 4.24748C12.003 4.24748 11.8441 4.18865 11.7193 4.08164C11.5946 3.97464 11.5123 3.82652 11.4873 3.66409C11.4915 3.57022 11.5132 3.47796 11.5513 3.39209",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1602 3.64796V2.06396",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4232 2.49609H4.5752",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08773 2.49609H1.42373C1.23556 2.50028 1.05651 2.57798 0.924922 2.71255C0.793337 2.84713 0.71968 3.02788 0.719727 3.21609V5.68009H15.2797V3.21609C15.2798 3.02788 15.2061 2.84713 15.0745 2.71255C14.9429 2.57798 14.7639 2.50028 14.5757 2.49609H12.9117",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarError);
export default __webpack_public_path__ + "static/media/calendar_error.bc5c1b6d.svg";
export { ForwardRef as ReactComponent };